export const learnMoreDisplayShouldFlex = ['48', '34'];
export const learnMoreDisplayShouldTable = ['81', '58', '74', '61', '69', '86', '64', '65', '46', '60', '37', '87'];
export const addClassToCarausalSectionChecker = ['19'];
export const changeClassForCurrentFund = ['31'];
export const checkOrgIdForLoginLayout = [
    50, 57, 56, 59, 62, 26, 61, 64, 66, 16, 70, 72, 68, 17, 67, 69, 75, 77, 74, 58, 46, 76, 63, 18, 28, 80, 81, 82, 83,
    84, 48,
];
export const checkOrgIdForInternalUseText = [
    80, 81, 83, 82, 57, 59, 62, 26, 61, 64, 66, 16, 70, 72, 68, 17, 67, 69, 75, 77, 74, 58, 46, 76, 63, 18, 28, 84, 48,
];
export const checkOrgIdForPngLogo = [1, 7, 8, 16, 19, 25, 27, 29, 31, 33, 34, 35, 36, 37, 38, 41, 50, 54, 55, 57, 85];
export const assetDisabledForFundDetails = [69];
export const checkRoleIdForFilter = [0, 1, 2, 5, 6, 7, 9, 10];
export const checkOrgForImpactImageForCropper = [52, 53, 78, 79];
export const checkForLockIconPositionOnLeft = [87];
export const menuCheckerForOnClickNotHavingLi = [87, 88, 89, 90, 92];
export const notRequiredAmountConversion = [89];
export const letterPanelFeature = ['89', '74', '88', '90', '72', '92'];
